import type { AppIconProps } from "../IconTypes";

export const SidebarCloseIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 3.5C0 2.70435 0.316071 1.94129 0.87868 1.37868C1.44129 0.816071 2.20435 0.5 3 0.5H21C21.7956 0.5 22.5587 0.816071 23.1213 1.37868C23.6839 1.94129 24 2.70435 24 3.5V18.5C24 19.2956 23.6839 20.0587 23.1213 20.6213C22.5587 21.1839 21.7956 21.5 21 21.5H3C2.20435 21.5 1.44129 21.1839 0.87868 20.6213C0.316071 20.0587 0 19.2956 0 18.5V3.5ZM7.5 2V20H21C21.3978 20 21.7794 19.842 22.0607 19.5607C22.342 19.2794 22.5 18.8978 22.5 18.5V3.5C22.5 3.10218 22.342 2.72064 22.0607 2.43934C21.7794 2.15804 21.3978 2 21 2H7.5ZM6 2H3C2.60218 2 2.22064 2.15804 1.93934 2.43934C1.65804 2.72064 1.5 3.10218 1.5 3.5V18.5C1.5 18.8978 1.65804 19.2794 1.93934 19.5607C2.22064 19.842 2.60218 20 3 20H6V2Z"
        fill="#1D9F81"
      />
    </svg>
  );
};
